import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const couponStatQuery = (companyId: string, gameId: string, couponId: string) => {
  return queryOptions({
    queryKey: [gameId, couponId, 'coupon-stat'],
    queryFn: () => dashboardClient.v1.getCouponStat({ companyId, gameId, couponId, last_count_days: 30 }),
    select: response => response.data,
  })
}

export const couponTotalStatQuery = (companyId: string, gameId: string, ids: string[]) => {
  return queryOptions({
    queryKey: [gameId, 'coupon-total-stat', { ids }],
    queryFn: () => dashboardClient.v1.getTotalCouponStat({ companyId, gameId, ids: ids.join(',') }),
    select: response => response.data,
  })
}
